module.exports = __webpack_public_path__ + "static/media/2.dfb93822.jpg";